import { getEnvironmentPaths } from "./utils.ts";
import store from "../store.js";
import { ISharepointListProperty } from "@/types/SPTypes.tsx";

export function buildListUrl(listName: string) {
  const environmentString = getEnvironmentPaths();
  const storeData = store.getState();
  const isLoggedIn = storeData.application.isLoggedIn;

  let urlString;
  if (isLoggedIn) {
    urlString =
      environmentString.vsdllistapi + "/GetByTitle('" + listName + "')/Items";
  } else {
    urlString =
      environmentString.listapi + "/GetByTitle('" + listName + "')/Items";
  }
  return urlString;
}

export function buildSelectQuery(listProperties: ISharepointListProperty[]) {
  let selectQuery = "?$select=";
  let expandQuery = "&$expand=";
  let isFirstProperty = true;

  for (const prop of listProperties) {
    let propNameQueryFormat = prop.name;

    if (prop.isLookup === true) {
      let count = 0;

      if (expandQuery === "&$expand=") {
        expandQuery += prop.name;
      } else {
        expandQuery += "," + prop.name;
      }

      prop.lookupListProperty.forEach(item => {
        // Hacky solution to account for actea.dev not being identical to real environment,
        //Need to be able  to get users from both with out calls failing (EMail and localhost if-block)
        if (!(item === "EMail" && window.location.hostname === "localhost")) {
          if (count > 0) {
            propNameQueryFormat += "," + prop.name + "/" + item;
          } else {
            propNameQueryFormat += "/" + item;
          }
        }
        count++;
      });
    }

    if (isFirstProperty) {
      selectQuery += propNameQueryFormat;
      isFirstProperty = false;
    } else {
      selectQuery += "," + propNameQueryFormat;
    }
  }
  if (expandQuery === "&$expand=") {
    expandQuery = "";
  }

  return selectQuery + expandQuery + "&$top=50000";
}
